module.exports = __webpack_public_path__ + "img/authority.2cd36ed2.png";